/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Tabs, TabProps } from '../components/TeaserTabs'
import HTMLParsedElement from './HTMLParsedElement'

export class TeaserTab extends HTMLElement {
}

export class TeaserTabs extends HTMLParsedElement {
  parsedCallback() {
    const mountPoint = document.createElement('div')
    this.attachShadow({ mode: 'open' }).appendChild(mountPoint)

    const tabs: TabProps[] = [];
    for(let i=0; i<this.children.length; i++) {
      const child = this.children[i];
      if(child.tagName === "TEASER-TAB") {
        const title = child.getAttribute('title') ?? "";
        const image = child.getAttribute('image') ?? "";
        child.setAttribute('slot', `tab-${i}`);
        tabs.push({title, image})
      }
    }
    createRoot(mountPoint).render(<Tabs tabs={tabs} styleRoot={mountPoint} />);
  }
}
customElements.define('teaser-tab', TeaserTab)
customElements.define('teaser-tabs', TeaserTabs)
